export default {"src":"/_next/static/media/mochi-coin-circle-color.36e37d7b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};